import { colors } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const FooterStyled = styled.footer`
  display: flex;
  justify-content: center;
  gap: 2rem;
  margin: 6.4rem auto 10rem;
  position: relative;
`;

export const CompleteDisabledReasonStyled = styled.p`
  color: ${colors.red[600]};
  font-size: 1.6rem;
  font-style: italic;
  max-width: 35rem;
  position: absolute;
`;
